<template>
  <div class="bookBuyResult">
    <div class="result">
      <template v-if="isPay">
        <van-image class="img" :src="require('@/assets/images/book/icon_success_01.png')" fit="cover"></van-image>
        <div class="text">兑换成功</div>
        <div class="btn btn_01" @click="$router.go(-2)">返回课程</div>
      </template>
      <template v-else>
        <van-image class="img" :src="require('@/assets/images/book/icon_success_02.png')" fit="cover"></van-image>
        <div class="text">购买成功</div>
        <div class="btn btn_02"  @click="$router.go(-2)">
          <template v-if="active !== 3">
            返回课程
          </template>
          <template v-else>
            返回教学资源
          </template>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {

  },
  components: {

  },
  data () {
    return {
      isPay: false,
      active: 0
    };
  },
  mounted () {
    const { $route: { query: { isPay, active } } } = this;
    this.isPay = isPay;
    this.active = active * 1;
  },
  methods: {

  }
};
</script>

<style scoped lang="less">
  .bookBuyResult{
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    .result{
      margin-top: 230px;
      text-align: center;
      .img{
        width: 144px;
        height: 176px;
        margin: 0px auto 40px;
        text-align: center;
      }
      .text{
        font-size: 34px;
        font-weight: bold;
        color: #333444;
        margin-bottom: 188px;
      }
      .btn{
        width: 450px;
        height: 76px;
        font-size: 28px;
        line-height: 76px;
        border-radius: 44px;
        &.btn_01{
          color: #5FA9FF;
          border: 2px solid #5FA9FF;
        }
        &.btn_02{
          color: #FCB645;
          border: 2px solid #FCB645;
        }
      }
    }
  }
</style>
